import { createRoot } from 'react-dom/client';
import React, { useRef, useLayoutEffect, useState } from "react";

import { ContactInfo, MarkdownItem } from "./App";
import { automationPost } from "./posts/automation";
import { standardsPost } from "./posts/standards";
import { productivityPost } from "./posts/productivity.js";
import { immrPost } from "./posts/immr.js";
import { trizPost } from "./posts/triz.js";



export function PostLink(props){
  return (
    <div className="news">
      <div className="news-date">{props.post.date}</div>
      <div className="news-text">
        <a href={props.post.url} >
          {props.post.title}
        </a>
      </div>
    </div>
  )
}

export function FeaturedPosts(props){
  return (
    <div className="blog-posts">
      <h2 className="underlined">Articles</h2>

      <PostLink post={immrPost} />
      <PostLink post={trizPost} />
      <PostLink post={productivityPost} />

      {props.children}
    </div>
  )
}

export function OlderPosts(props) {
  return(
    <div>
      <PostLink post={standardsPost} />
      <PostLink post={automationPost} />
    </div>
  )
}

export function SinglePostPage(props) {
  return (
    <div>
      <div className="grey-color-bar"></div>
      <div className="secondary-page post-page">
        <a href="/">« Home</a>
        <a href="/posts" style={{paddingLeft:'6px'}}> « Posts</a>
        <div className="post">
          <MarkdownItem src={props.post.body} setClasses={'post-inner'} />
        </div>
      </div>
      <div className="grey-color-bar-bottom"></div>
    </div>
  )
}

export function PostsPage(props){
  return (
    <div className='main'>
      <div className="header">
        <div className="grey-color-bar"></div>
        <div className="secondary-page">
          {/* <ContactInfo/> */}
          <div style={{padding: '20px 20px 90px 20px '}}>
           <a href="/">« Home</a>
            <FeaturedPosts/>
            <OlderPosts/>
          </div>
        </div>
      </div>
      <div className="grey-color-bar-bottom"></div>
    </div>
  )
}

